import { render, staticRenderFns } from "./AboutArticles.vue?vue&type=template&id=3beaa991"
import script from "./AboutArticles.vue?vue&type=script&lang=js"
export * from "./AboutArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports